import { render } from "./results.vue?vue&type=template&id=d59a8fc2&scoped=true&ts=true"
import script from "./results.vue?vue&type=script&lang=ts"
export * from "./results.vue?vue&type=script&lang=ts"

import "./results.vue?vue&type=style&index=0&id=d59a8fc2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59a8fc2"]])

export default __exports__